import React from "react";
import CountBg from "../../assets/image/png/count-bg.png";
import HowItWork from "../../assets/image/png/how-it-works.png";
const HowItWorks = () => {
  return (
    <div
      style={{
        backgroundColor: "white",
        paddingTop: "50px",
        paddingBottom: "50px",
        position: "relative",
        marginBottom: "30px",
      }}
    >
      <img
        className="position-absolute bottom-0 end-0 d-none d-md-block"
        src={HowItWork}
        alt=""
      />
      <div className="container">
        <h3 className="mb-0 fs_48 ff_inter text-center fw-bold color_darkgray">
          How It
          <span className=" color_blue"> Works</span>
        </h3>
        <div className="row mt-3 col-md-9 mx-auto">
          <div className="col-md-6 d-flex align-items-center mt-4">
            <div className="position-relative">
              <img src={CountBg} alt="blue" />
              <span className="fw-bold fs_90 position-absolute top-50 start-50 translate-middle">
                1
              </span>
            </div>
            <div className="ms-4">
              <p className="mb-1 fw-bold fs_20 ff_inter">
                Share Your Drone's Issue
              </p>
              <p className="mb-0 fw_normal fs_15 ff_inter">
                Fill out our simple online form to let us know what's wrong with
                your drone.
              </p>
            </div>
          </div>
          <div className="col-md-6 d-flex align-items-center mt-4">
            <div className="position-relative">
              <img src={CountBg} alt="blue" />
              <span className="fw-bold fs_90 position-absolute top-50 start-50 translate-middle">
                2
              </span>
            </div>
            <div className="ms-4">
              <p className="mb-1 fw-bold fs_20 ff_inter">
                Send Your Drone to Us
              </p>
              <p className="mb-0 fw_normal fs_15 ff_inter">
                Once approved, securely ship your drone to us using our provided
                instructions.
              </p>
            </div>
          </div>
          <div className="col-md-6 d-flex align-items-center mt-4">
            <div className="position-relative">
              <img src={CountBg} alt="blue" />
              <span className="fw-bold fs_90 position-absolute top-50 start-50 translate-middle">
                3
              </span>
            </div>
            <div className="ms-4">
              <p className="mb-1 fw-bold fs_20 ff_inter">Expert Repair</p>
              <p className="mb-0 fw_normal fs_15 ff_inter">
                Our technicians will diagnose and repair your drone using
                high-quality parts.
              </p>
            </div>
          </div>
          <div className="col-md-6 d-flex align-items-center mt-4">
            <div className="position-relative">
              <img src={CountBg} alt="blue" />
              <span className="fw-bold fs_90 position-absolute top-50 start-50 translate-middle">
                4
              </span>
            </div>
            <div className="ms-4">
              <p className="mb-1 fw-bold fs_20 ff_inter">Return to Flight</p>
              <p className="mb-0 fw_normal fs_15 ff_inter">
                We'll ship your drone back to you, ready for your next flight
                adventure.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
